import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOperatorElearningTopicVm } from '../operator-elearning-topic-vm.model';
import { IOperatorElearningTopicIm } from '../operator-elearning-topic-im.model';
import { IOperatorElearningTopicUm } from '../operator-elearning-topic-um.model';
@Injectable({ providedIn: 'root' })
export class OperatorElearningTopicService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorElearningTopic`;
  }
  get(id: number): Observable<IOperatorElearningTopicVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (id !== undefined && id !== null) {
      params = params.set('id', id.toString());
    }
    return this.http.get<IOperatorElearningTopicVm>(this.baseUrl, { headers, params });
  }
  post(operatorElearningTopicIm: IOperatorElearningTopicIm): Observable<IOperatorElearningTopicVm> {
    const headers = this.createHeaders();
    return this.http.post<IOperatorElearningTopicVm>(this.baseUrl, operatorElearningTopicIm, { headers });
  }
  put(operatorElearningTopicUm: IOperatorElearningTopicUm): Observable<IOperatorElearningTopicVm> {
    const headers = this.createHeaders();
    return this.http.put<IOperatorElearningTopicVm>(this.baseUrl, operatorElearningTopicUm, { headers });
  }
  delete(id: number): Observable<any> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (id !== undefined && id !== null) {
      params = params.set('id', id.toString());
    }
    return this.http.delete<any>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
